<template>
  <div class="home">
    <div class="header">
      <!-- <div class="name">JoyMe</div> -->
      <!-- <div class="name">JoyInMe</div> -->
      <div class="name">In2Fun</div>
    </div>
    <div class="content">
      <!-- <div class="name">JoyMe</div> -->
      <!-- <div class="name">JoyInMe</div> -->
      <div class="name">In2Fun</div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
// @ is an alias to /src
import FooterView from '@/components/footer.vue';

export default {
  name: 'Home',
  components: {
    FooterView,
  },
};
</script>
<style lang="less" scoped>
.home{
  width: 100%;
  height: 100%;
  // background: url('../assets/images/bg.png') no-repeat center transparent;
  background: url('../assets/images/bg1.png') no-repeat center bottom transparent;
  background-size: contain;
  .header{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: .64rem;
    line-height: .64rem;
    font-size: .24rem;
    padding: 0 1rem;
    // background: #feb00a;
    background: #9a3cf6;
    border-bottom: 1px solid #fea00a;
    color: #fff;
  }
  .content{
    height: 100%;
    width: 100%;
    padding-top: .64rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .name{
      font-size: .48rem;
      color: #999;
    }
  }
}
</style>
